import { Box, Card, CardContent, Container, Grid } from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import { InfoOperater, Loading } from "../../components";
import { FormProvider, useForm } from "react-hook-form";
import { fetcherBlob } from "../../utils/fetcher";
import { useMojiPodaci } from "../../hooks";

const Index = () => {
  const methods = useForm();
  const linkRef = useRef<HTMLAnchorElement>(null);
  const linkRefEn = useRef<HTMLAnchorElement>(null);
  const [data, setData] = useState<Blob | null>(null);
  const { operaterPlatforme } = useMojiPodaci(methods);

  useEffect(() => {
    const fetchData = async () => {
      methods.setValue("loading", true);
      const response = await fetcherBlob(
        `${process.env.REACT_APP_API_URL}/operateri/upute`,
        {}
      );
      setData(response);
      methods.setValue("loading", false);
    };
    fetchData();
  }, []);

  const url = useMemo(() => {
    if (!data || linkRef.current === null) return "/";
    linkRef.current.download = "Tehničke upute za korisnike.pdf";
    return window.URL.createObjectURL(new File([data], "filename.pdf"));
  }, [data]);

  const urlEn = useMemo(() => {
    if (!data || linkRefEn.current === null) return "/";
    linkRefEn.current.download = "User manual.pdf";
    return window.URL.createObjectURL(new File([data], "filename.pdf"));
  }, [data]);

  return (
    <FormProvider {...methods}>
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box component={"form"}>
              <InfoOperater />
              <Card variant={"outlined"} sx={{ mt: 3, position: "relative" }}>
                <CardContent>
                  <p>
                    U svrhu dostave podatak potrebno je pogledati dokument:{" "}
                    <a ref={linkRef} href={url}>
                      Tehničke upute
                    </a>
                    (For submitting information, it is necessary to view the
                    document:{" "}
                    <a ref={linkRefEn} href={urlEn}>
                      Technical instructions
                    </a>
                    )
                  </p>
                  <p>
                    Dokumentom se opisuju sve poruke koje sustavi razmjenjuju,
                    procesi razmjene poruka, definiraju se podatkovni skupovi i
                    pravila koja je nužno poštivati u komunikaciji. <br />{" "}
                    Razmjena podataka odvijat će se putem Web servisa
                    korištenjem XML poruka. Upravo takav način razmjene podataka
                    nije ovisan ni o tehnologiji koju koriste obveznici
                    fiskalizacije ni o tehnologiji koju koristi Porezna uprava i
                    omogućuje uniformnu komunikaciju između bilo kojeg obveznika
                    fiskalizacije i Porezne uprave.
                  </p>
                  <p>
                    The document describes all the messages exchanged by the
                    systems, message exchange processes, defines the data groups
                    and the rules to be followed in communication. <br />{" "}
                    Information exchange will take place via Web service through
                    XML messages. This method of information exchange is
                    independent of technology used by fiscalisation subjects and
                    the technology used by the Tax Administration and allows for
                    a uniform communication between any fiscalisation subjects
                    and the Tax Administration.
                  </p>
                </CardContent>
              </Card>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Loading />
    </FormProvider>
  );
};

export default Index;
